import React, { useState } from 'react';
import { UpgradeDialog } from '../UpgradeDialog';
import './ReadOnlyBanner.css';

interface ReadOnlyBannerProps {
  daysUntilDeletion?: number;
}

const ReadOnlyBanner: React.FC<ReadOnlyBannerProps> = ({ daysUntilDeletion }) => {
  const [upgradeDialogOpen, setUpgradeDialogOpen] = useState(false);

  return (
    <>
      <div className="readonly-banner">
        <p>
          You are currently in <strong>view-only</strong> mode.{' '}
          {daysUntilDeletion !== undefined && daysUntilDeletion >= 0 && (
            <>Your data will be deleted in {daysUntilDeletion} day{daysUntilDeletion === 1 ? '' : 's'}. </>
          )}
          Upgrade your plan to continue using Coach features and uploading new data.
        </p>
        <button className="upgrade-cta" onClick={() => setUpgradeDialogOpen(true)}>Upgrade now</button>
      </div>
      <UpgradeDialog
        isOpen={upgradeDialogOpen}
        onClose={() => setUpgradeDialogOpen(false)}
        feature="Coach features and data uploads"
        requiredPlan="basic"
      />
    </>
  );
};

export default ReadOnlyBanner;
